import { defineMessages } from "react-intl";

const UPDATE = "update";

const updateMessages = defineMessages({
  myAccount: {
    id: `${UPDATE}.my-account`,
    defaultMessage: "My account"
  },
  myEBSCODataRetentionAndUsage: {
    id: `${UPDATE}.myebsco-data-retention-and-usage`,
    defaultMessage: "MyEBSCO data retention and usage"
  }
});

export default updateMessages;
